import axios, { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Profile } from '~/types/models';
import { TaggableResourceType } from '~/types/models/tags';

export interface ManageResourceContactParams {
  resourceUuid: string;
  resourceType: TaggableResourceType;
  profileUuid: string;
}

type AssignResourceContactResponse = {
  message: string;
  data: Profile;
};

const assignResourceContact = (params: ManageResourceContactParams) => {
  return axios.post<AssignResourceContactResponse>('/api/v3/resource-contact', {
    resource_uuid: params.resourceUuid,
    resource_type: params.resourceType,
    profile_uuid: params.profileUuid,
  });
};

const unassignResourceContact = (params: ManageResourceContactParams) => {
  return axios.delete<{ message: string }>('/api/v3/resource-contact', {
    params: {
      resource_uuid: params.resourceUuid,
      resource_type: params.resourceType,
      profile_uuid: params.profileUuid,
    },
  });
};

export interface ManageResourceContactHookParams {
  options?: UseMutationOptions<
    AxiosResponse,
    AxiosError,
    ManageResourceContactParams
  >;
}

const useAssignResourceContact = (params: ManageResourceContactHookParams) => {
  return useMutation(assignResourceContact, {
    ...params.options,
  });
};

const useUnassignResourceContact = (
  params: ManageResourceContactHookParams
) => {
  return useMutation(unassignResourceContact, {
    ...params.options,
  });
};

export { useAssignResourceContact, useUnassignResourceContact };
